// Payment pack form config

export const paymentPackFields = [
    {
        key: 'payment-pack-information',
        name: 'Payment Pack Information',
        fields: [
            {
                name: 'payment_pack_received',
                label: 'Payment Pack Received',
                type: 'date',
                validation: {},
            },
            {
                name: 'losses_included',
                label: 'Losses Included',
                type: 'float',
                validation: {},
            },
            {
                name: 'date_of_payment_pack',
                label: 'Date of Payment Pack',
                type: 'date',
                validation: {},
            },
            {
                name: 'date_payment_pack_received',
                label: 'Date Payment Pack Received',
                type: 'date',
                validation: {},
            },
            {
                name: 'date_of_1_st_lpp_clock',
                label: 'Date of 1st LPP clock',
                type: 'date',
                validation: {},
            },
            {
                name: 'date_removed_from_abi_gta',
                label: 'Date removed from ABI GTA',
                type: 'date',
                validation: {},
            },
            {
                name: 'payment_pack_received_2',
                label: 'Payment Pack Received (2)',
                type: 'date',
                validation: {},
            },
            {
                name: 'payment_pack_received_3',
                label: 'Payment Pack Received (3)',
                type: 'date',
                validation: {},
            },
            {
                name: 'cho_ref',
                label: 'CHO Reference',
                type: 'text',
                validation: {},
            },
            {
                name: 'insurer_ref',
                label: 'Insurer Reference',
                type: 'text',
                validation: {},
            },
            {
                name: 'policy_number',
                label: 'Policy Number',
                type: 'text',
                validation: {},
            },
            {
                name: 'cho_reg_no',
                label: 'CHO Registration Number',
                type: 'text',
                validation: {},
            },
            {
                name: 'insurer_reg_no',
                label: 'Insurer Registration Number',
                type: 'text',
                validation: {},
            },
        ],
    },
    {
        key: 'enforceability',
        name: 'Enforceability',
        fields: [
            {
                name: 'are_all_documents_present',
                label: 'Are all document present?',
                type: 'boolean',
                dependencySource: true,
                dependencyMatchValue: 0,
                validation: {},
            },
            {
                name: 'mitigation_statement_present',
                label: 'Mitigation Statement Present?',
                type: 'text',
                dependency: {
                    type: 'visibility',
                    sourceField: 'are_all_documents_present',
                    matchValue: 0 // this field will be visible when "are_all_documents_present" is 0
                },
                validation: {},
            },
            {
                name: 'rental_agreement_present',
                label: 'Rental Agreement Present?',
                type: 'text',
                dependency: {
                    type: 'visibility',
                    sourceField: 'are_all_documents_present',
                    matchValue: 0 // this field will be visible when "are_all_documents_present" is 0
                },
                validation: {},
            },
            {
                name: 'cancellation_statement_present',
                label: 'Cancellation Statement Present?',
                type: 'text',
                dependency: {
                    type: 'visibility',
                    sourceField: 'are_all_documents_present',
                    matchValue: 0 // this field will be visible when "are_all_documents_present" is 0
                },
                validation: {},
            },
            {
                name: 'other_required_documents_present',
                label: 'Other required documents present?',
                type: 'boolean',
                dependencySource: true,
                dependencyMatchValue: 1,
                validation: {},
            },
            {
                name: 'other_required_documents_present_type',
                label: 'Other required documents present type',
                type: 'text',
                dependency: {
                    type: 'visibility',
                    sourceField: 'other_required_documents_present',
                    matchValue: 1 // this field will be visible when "other_required_documents_present" is 1
                },
                validation: {},
            },
            {
                name: 'lou_dates_present',
                label: 'LOU Dates Present?',
                type: 'text',
                validation: {},
            },
            {
                name: 'all_signatures_present',
                label: 'All Signatures Present?',
                type: 'boolean',
                validation: [{ name: 'required' }]
            },
            {
                name: 'all_signatures_consistent',
                label: 'All Signatures Consistent?',
                type: 'boolean',
                validation: [{ name: 'required' }]
            },
            {
                name: 'signed_by_hirer',
                label: 'Signed by Hirer?',
                type: 'date',
                validation: [{ name: 'required' }]
            },
            {
                name: 'signee_authorised_to_bind',
                label: 'Signee Authorised to Bind?',
                type: 'boolean',
                validation: [{ name: 'required' }]
            },
            {
                name: 'claimant_is_a_minor',
                label: 'Claimant is a Minor?',
                type: 'boolean',
                validation: {},
            },
            {
                name: 'payment_within_12_months',
                label: 'Payment within 12 months?',
                type: 'boolean',
                validation: [{ name: 'required' }]
            },
            {
                name: 'payment_in_no_more_than_4_instalments',
                label: 'Payment in no more than 4 instalments?',
                type: 'boolean',
                validation: [{ name: 'required' }]
            },
            {
                name: 'hire_duration_exceeds_90_days',
                label: 'Hire duration exceeds 90 days?',
                type: 'boolean',
                disabled: true,
                validation: [{ name: 'required' }]
            },
            {
                name: 'date_first_ra_signed',
                label: 'Date first RA signed',
                type: 'date',
                validation: [{ name: 'required' }]
            },
            {
                name: 'any_other_enforceability_concerns',
                label: 'Any Other Enforceability Concerns?',
                type: 'text',
                validation: {},
            },
            {
                name: 'concerns_details',
                label: 'Concerns details',
                type: 'text',
                validation: {},
            },
        ],
    },
    {
        key: 'need',
        name: 'Need',
        fields: [
            {
                name: 'any_concerns_regarding_need',
                label: 'Any Concerns Regarding Need',
                type: 'text',
                validation: {},
            },
            {
                name: 'other_vehicles_available',
                label: 'Other Vehicles Available?',
                type: 'text',
                validation: {},
            },
            {
                name: 'claimant_vehicle_annual_mileage',
                label: 'Claimant vehicle annual mileage',
                type: 'integer',
                validation: {},
            },
            {
                name: 'taxi_hire',
                label: 'Taxi Hire?',
                type: 'text',
                validation: {},
            },
            {
                name: 'profit_earning_eg_courier_delivery_driver',
                label: 'Profit Earning (Eg: Courier/Delivery Driver)',
                type: 'text',
                validation: {},
            },
            {
                name: 'company_vehicle',
                label: 'Company Vehicle?',
                type: 'text',
                validation: {},
            },
            {
                name: 'fleet_utilisation',
                label: 'Fleet Utilisation?',
                type: 'text',
                validation: {},
            },
            {
                name: 'weekend_biker',
                label: 'Weekend biker?',
                type: 'boolean',
                validation: {},
            },
            {
                name: 'rare_classic_vehicle',
                label: 'Rare/Classic Vehicle?',
                type: 'text',
                validation: {},
            },
        ],
    },
    {
        key: 'hire',
        name: 'Hire',
        fields: [
            {
                name: 'hire_start_date_1',
                label: 'Hire Period (1)',
                type: 'date_range_start',
                dateRange: {
                    key: 'pp_hire_dates',
                    index: 0,
                    total: 5
                },
                endKey: 'hire_end_date_1',
                calculate: {
                    type: 'days',
                    targetField: 'number_of_days_claimed_1',
                    totalField: 'total_number_of_hire_days_claimed',
                    extraCalculate: {
                        type: 'daysOver',
                        value: 90,
                        targetField: 'hire_duration_exceeds_90_days'
                    }
                },
                changesOtherFieldsValues: true,
                validation: [{ name: 'dateRange' }, { name: 'required' }],
                modalValidation: [{ name: 'dateRange' }]
            },
            {
                name: 'hire_end_date_1',
                label: 'Hire End Date (1)',
                type: 'date_range_end',
                startKey: 'hire_start_date_1',
                validation: [{ name: 'required' }]
            },
            {
                name: 'number_of_days_claimed_1',
                label: 'Number of Days Claimed (1)',
                type: 'integer',
                custom_placeholder:" ",
                disabled: true,
                group: {
                    key: 'pp_hire_dates',
                    index: 0,
                    total: 5
                },
                calculate: {
                    type: 'days',
                    group: 'pp_hire_dates',
                    totalField: 'total_number_of_hire_days_claimed'
                },
                validation: {},
            },
            {
                name: 'hire_start_date_2',
                label: 'Hire Period (2)',
                type: 'date_range_start',
                dateRange: {
                    key: 'pp_hire_dates',
                    index: 1,
                    total: 5
                },
                endKey: 'hire_end_date_2',
                calculate: {
                    type: 'days',
                    targetField: 'number_of_days_claimed_2',
                    totalField: 'total_number_of_hire_days_claimed'
                },
                changesOtherFieldsValues: true,
                validation: {},
                modalValidation: [{ name: 'dateRange' }]
            },
            {
                name: 'hire_end_date_2',
                label: 'Hire End Date (2)',
                type: 'date_range_end',
                startKey: 'hire_start_date_2',
                validation: {}
            },
            {
                name: 'number_of_days_claimed_2',
                label: 'Number of Days Claimed (2)',
                type: 'integer',
                custom_placeholder:" ",
                disabled: true,
                group: {
                    key: 'pp_hire_dates',
                    index: 1,
                    total: 5
                },
                calculate: {
                    type: 'days',
                    group: 'pp_hire_dates',
                    totalField: 'total_number_of_hire_days_claimed'
                },
                validation: {},
            },
            {
                name: 'hire_start_date_3',
                label: 'Hire Period (3)',
                type: 'date_range_start',
                dateRange: {
                    key: 'pp_hire_dates',
                    index: 2,
                    total: 5
                },
                endKey: 'hire_end_date_3',
                calculate: {
                    type: 'days',
                    targetField: 'number_of_days_claimed_3',
                    totalField: 'total_number_of_hire_days_claimed'
                },
                changesOtherFieldsValues: true,
                validation: {},
                modalValidation: [{ name: 'dateRange' }]
            },
            {
                name: 'hire_end_date_3',
                label: 'Hire End Date (3)',
                type: 'date_range_end',
                startKey: 'hire_start_date_3',
                validation: {}
            },
            {
                name: 'number_of_days_claimed_3',
                label: 'Number of Days Claimed (3)',
                type: 'integer',
                custom_placeholder:" ",
                disabled: true,
                group: {
                    key: 'pp_hire_dates',
                    index: 2,
                    total: 5
                },
                calculate: {
                    type: 'days',
                    group: 'pp_hire_dates',
                    totalField: 'total_number_of_hire_days_claimed'
                },
                validation: {},
            },
            {
                name: 'hire_start_date_4',
                label: 'Hire Period (4)',
                type: 'date_range_start',
                dateRange: {
                    key: 'pp_hire_dates',
                    index: 3,
                    total: 5
                },
                endKey: 'hire_end_date_4',
                calculate: {
                    type: 'days',
                    targetField: 'number_of_days_claimed_4',
                    totalField: 'total_number_of_hire_days_claimed'
                },
                changesOtherFieldsValues: true,
                validation: {},
                modalValidation: [{ name: 'dateRange' }]
            },
            {
                name: 'hire_end_date_4',
                label: 'Hire End Date (4)',
                type: 'date_range_end',
                startKey: 'hire_start_date_4',
                validation: {}
            },
            {
                name: 'number_of_days_claimed_4',
                label: 'Number of Days Claimed (4)',
                type: 'integer',
                custom_placeholder:" ",
                disabled: true,
                group: {
                    key: 'pp_hire_dates',
                    index: 3,
                    total: 5
                },
                calculate: {
                    type: 'days',
                    group: 'pp_hire_dates',
                    totalField: 'total_number_of_hire_days_claimed'
                },
                validation: {},
            },
            {
                name: 'hire_start_date_5',
                label: 'Hire Period (5)',
                type: 'date_range_start',
                dateRange: {
                    key: 'pp_hire_dates',
                    index: 4,
                    total: 5
                },
                endKey: 'hire_end_date_5',
                calculate: {
                    type: 'days',
                    targetField: 'number_of_days_claimed_5',
                    totalField: 'total_number_of_hire_days_claimed'
                },
                changesOtherFieldsValues: true,
                validation: {},
                modalValidation: [{ name: 'dateRange' }]
            },
            {
                name: 'hire_end_date_5',
                label: 'Hire End Date (5)',
                type: 'date_range_end',
                startKey: 'hire_start_date_5',
                validation: {}
            },
            {
                name: 'number_of_days_claimed_5',
                label: 'Number of Days Claimed (5)',
                type: 'integer',
                custom_placeholder:" ",
                disabled: true,
                group: {
                    key: 'pp_hire_dates',
                    index: 4,
                    total: 5
                },
                calculate: {
                    type: 'days',
                    group: 'pp_hire_dates',
                    totalField: 'total_number_of_hire_days_claimed'
                },
                validation: {},
            },
            {
                name: 'total_number_of_hire_days_claimed',
                label: 'Total Number of Hire Days Claimed',
                type: 'integer',
                custom_placeholder:" ",
                disabled: true,
                validation: {},
            },
            {
                name: 'hire_group_claimed',
                label: 'GTA - Hire Group Claimed',
                type: 'text',
                validation: {},
            },
            {
                name: 'hire_daily_rate_claimed',
                label: 'GTA - Hire Daily Rate Claimed',
                type: 'float',
                validation: [{ name: 'required' }]
            },
            {
                name: 'hire_daily_rate_extra_per_day_claimed',
                label: 'GTA - Hire Daily Rate Extra per day Claimed',
                type: 'float',
                validation: {},
            },
            {
                name: 'auto',
                label: 'GTA - Auto Daily Rate',
                type: 'float',
                validation: [{ name: 'required' }]
            },
            {
                name: 'estate',
                label: 'Estate',
                type: 'float',
                validation: [{ name: 'required' }]
            },
            {
                name: 'dual_control_insurance_provided',
                label: 'Dual Control insurance provided',
                type: 'boolean',
                validation: [{ name: 'required' }]
            },
            {
                name: 'top_box',
                label: 'Top Box',
                type: 'float',
                validation: [{ name: 'required' }]
            },
            {
                name: 'pannier',
                label: 'Pannier',
                type: 'float',
                validation: [{ name: 'required' }]
            },
            {
                name: 'total_daily_rate_claimed',
                label: 'Total Daily Rate Claimed',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_daily_rate_vat_claimed',
                label: 'Total Daily Rate VAT Claimed',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_hire_claimed_abi_gta_with_2_percent_discount',
                label: 'Total Hire Claimed (ABI GTA - With 2% Discount)',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_hire_claimed_vat_abi_gta_with_2_percent_discount',
                label: 'Total Hire Claimed VAT (ABI GTA - With 2% Discount)',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_hire_claimed_abi_gta_amount_only',
                label: 'Total Hire Claimed (ABI GTA Amount Only)',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_hire_claimed_vat_abi_gta_amount_only',
                label: 'Total Hire Claimed VAT (ABI GTA Amount Only)',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_hire_claimed_abi_gta_with_15_percent_lpp',
                label: 'Total Hire Claimed (ABI GTA - With 15% LPP)',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_hire_claimed_vat_abi_gta_with_15_percent_lpp',
                label: 'Total Hire Claimed VAT (ABI GTA - With 15% LPP)',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_hire_claimed_ngta_or_abi_gta_commercial_rate',
                label: 'Total Hire Claimed (NGTA or ABI GTA Commercial Rate)',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_hire_claimed_vat_ngta_or_abi_gta_commercial_rate',
                label: 'Total Hire Claimed VAT (NGTA or ABI GTA Commercial Rate)',
                type: 'float',
                validation: {},
            },
        ],
    },
    {
        key: 'admin-fee',
        name: 'Admin Fee',
        fields: [
            {
                name: 'abi_admin_claimed',
                label: 'ABI Admin Claimed',
                type: 'float',
                validation: {},
            },
            {
                name: 'abi_admin_vat',
                label: 'ABI Admin VAT',
                type: 'float',
                validation: {},
            },
            {
                name: 'abi_admin_claimed_abi_gta_with_2_percent_discount',
                label: 'ABI Admin Claimed (ABI GTA - With 2% Discount)',
                type: 'float',
                validation: {},
            },
            {
                name: 'abi_admin_vat_abi_gta_with_2_percent_discount',
                label: 'ABI Admin VAT (ABI GTA - With 2% Discount)',
                type: 'float',
                validation: {},
            },
            {
                name: 'abi_admin_claimed_abi_gta_amount_only',
                label: 'ABI Admin Claimed (ABI GTA Amount Only)',
                type: 'float',
                validation: {},
            },
            {
                name: 'abi_admin_vat_abi_gta_amount_only',
                label: 'ABI Admin VAT (ABI GTA Amount Only)',
                type: 'float',
                validation: {},
            },
            {
                name: 'abi_admin_claimed_abi_gta_with_15_percent_lpp',
                label: 'ABI Admin Claimed (ABI GTA - With 15% LPP)',
                type: 'float',
                validation: {},
            },
            {
                name: 'abi_admin_vat_abi_gta_with_15_percent_lpp',
                label: 'ABI Admin VAT (ABI GTA - With 15% LPP)',
                type: 'float',
                validation: {},
            },
            {
                name: 'abi_admin_claimed_ngta_or_abi_gta_commercial_rate',
                label: 'ABI Admin Claimed (NGTA or ABI GTA Commercial Rate)',
                type: 'float',
                validation: {},
            },
            {
                name: 'abi_admin_vat_ngta_or_abi_gta_commercial_rate',
                label: 'ABI Admin VAT (NGTA or ABI GTA Commercial Rate)',
                type: 'float',
                validation: {},
            },
            {
                name: 'repair_abi_admin_claimed',
                label: 'Repair ABI Admin Claimed',
                type: 'float',
                validation: {},
            },
            {
                name: 'repair_abi_admin_vat',
                label: 'Repair ABI Admin VAT',
                type: 'float',
                validation: {},
            },
            {
                name: 'engineers_fee_claimed',
                label: 'Engineers Fee Claimed',
                type: 'float',
                validation: {},
            },
            {
                name: 'engineers_fee_vat',
                label: 'Engineers Fee VAT',
                type: 'float',
                validation: {},
            },
        ]
    },
    {
        key: 'repairs',
        name: 'Repairs',
        fields: [
            {
                name: 'repair_claimed_total_exc_vat',
                label: 'Repair Claimed Total (exc VAT)',
                type: 'float',
                validation: {},
            },
            {
                name: 'repair_claimed_total_vat',
                label: 'Repair Claimed Total VAT',
                type: 'float',
                validation: {},
            },
            {
                name: 'repair_claimed_total_exc_vat_abi_gta_with_2_percent_discount',
                label: 'Repair Claimed Total (exc VAT)(ABI GTA - With 2% Discount)',
                type: 'float',
                validation: {},
            },
            {
                name: 'repair_claimed_total_vat_abi_gta_with_2_percent_discount',
                label: 'Repair Claimed Total VAT(ABI GTA - With 2% Discount)',
                type: 'float',
                validation: {},
            },
            {
                name: 'repair_claimed_total_exc_vat_abi_gta_amount_only',
                label: 'Repair Claimed Total (exc VAT) (ABI GTA Amount Only)',
                type: 'float',
                validation: {},
            },
            {
                name: 'repair_claimed_total_vat_abi_gta_amount_only',
                label: 'Repair Claimed Total VAT(ABI GTA Amount Only)',
                type: 'float',
                validation: {},
            },
            {
                name: 'repair_claimed_total_exc_vat_abi_gta_with_2_5_percent_lpp',
                label: 'Repair Claimed Total (exc VAT)(ABI GTA - With 2.5% LPP)',
                type: 'float',
                validation: {},
            },
            {
                name: 'repair_claimed_total_vat_abi_gta_with_2_5_percent_lpp',
                label: 'Repair Claimed Total VAT (ABI GTA - With 2.5% LPP)',
                type: 'float',
                validation: {},
            },
            {
                name: 'repair_abi_admin_claimed_abi_gta_with_2_5_percent_lpp',
                label: 'Repair ABI Admin Claimed (ABI GTA - With 2.5% LPP)',
                type: 'float',
                validation: {},
            },
            {
                name: 'repair_abi_admin_vat_claimed_abi_gta_with_2_5_percent_lpp',
                label: 'Repair ABI Admin VAT Claimed (ABI GTA - With 2.5% LPP)',
                type: 'float',
                validation: {},
            },
            {
                name: 'repair_claimed_total_exc_vat_ngta_or_abi_gta_commercial_rate',
                label: 'Repair Claimed Total (exc VAT) (NGTA or ABI GTA Commercial Rate)',
                type: 'float',
                validation: {},
            },
            {
                name: 'repair_claimed_total_vat_ngta_or_abi_gta_commercial_rate',
                label: 'Repair Claimed Total VAT(NGTA or ABI GTA Commercial Rate)',
                type: 'float',
                validation: {},
            },
            {
                name: 'labour_hours_claimed',
                label: 'Labour Hours Claimed',
                type: 'integer',
                validation: {},
            },
            {
                name: 'labour_rate_per_hour_exc_vat',
                label: 'Labour Rate Per Hour (exc VAT)',
                type: 'float',
                validation: {},
            },
            {
                name: 'labour_rate_per_hour_vat',
                label: 'Labour Rate Per Hour VAT',
                type: 'float',
                validation: {},
            },
            {
                name: 'labour_total_exc_vat',
                label: 'Labour Total (exc VAT)',
                type: 'float',
                validation: {},
            },
            {
                name: 'labour_total_vat',
                label: 'Labour Total VAT',
                type: 'float',
                validation: {},
            },
            {
                name: 'parts_total_exc_vat',
                label: 'Parts Total (Exc VAT)',
                type: 'float',
                validation: {},
            },
            {
                name: 'parts_vat',
                label: 'Parts VAT',
                type: 'float',
                validation: {},
            },
            {
                name: 'paint_materials_total_exc_vat',
                label: 'Paint & Materials Total (Exc VAT)',
                type: 'float',
                validation: {},
            },
            {
                name: 'paints_materials_vat',
                label: 'Paints & Materials VAT',
                type: 'float',
                validation: {},
            },
            {
                name: 'specialist_total_exc_vat',
                label: 'Specialist Total (Exc VAT)',
                type: 'float',
                validation: {},
            },
            {
                name: 'specialist_vat',
                label: 'Specialist VAT',
                type: 'float',
                validation: {},
            },
        ]
    },
    {
        key: 'storage-and-recovery',
        name: 'Storage and Recovery',
        fields: [
            {
                name: 'storage_claimed',
                label: 'Storage Claimed',
                type: 'float',
                validation: {},
            },
            {
                name: 'storage_claimed_vat',
                label: 'Storage Claimed VAT',
                type: 'float',
                validation: {},
            },
            {
                name: 'recovery_claimed',
                label: 'Recovery Claimed',
                type: 'float',
                validation: {},
            },
            {
                name: 'recovery_claimed_vat',
                label: 'Recovery Claimed VAT',
                type: 'float',
                validation: {},
            },
        ]
    },
    {
        key: 'dimunition-and-other',
        name: 'Diminution and Other',
        fields: [
            {
                name: 'dimunition_claimed',
                label: 'Diminution Claimed',
                type: 'float',
                validation: {},
            },
            {
                name: 'dimunition_claimed_vat',
                label: 'Diminution Claimed VAT',
                type: 'float',
                validation: {},
            },
            {
                name: 'other_claimed',
                label: 'Other Claimed',
                type: 'float',
                validation: {},
            },
            {
                name: 'other_claimed_vat',
                label: 'Other Claimed VAT',
                type: 'float',
                validation: {},
            },
        ]
    },
    {
        key: 'payment-pack-claimed',
        name: 'Payment Pack Claimed',
        fields: [
            {
                name: 'daily_hire_rate',
                label: 'Daily Hire Rate',
                type: 'float',
                validation: {},
            },
            {
                name: 'daily_hire_rate_with_lpp',
                label: 'Daily Hire Rate with LPP',
                type: 'float',
                validation: {},
            },
            {
                name: 'litigated_daily_rate',
                label: 'Litigated Daily Rate',
                type: 'float',
                validation: {},
            },
            {
                name: 'daily_hire_rate_commercial_rate',
                label: 'Daily Hire Rate (Commercial Rate)',
                type: 'float',
                validation: {},
            },
            {
                name: 'hrd_total_claimed',
                label: 'GTA - HRD total claimed',
                type: 'float',
                validation: {},
            },
            {
                name: 'dual_control',
                label: 'Dual Control',
                type: 'float',
                validation: [{ name: 'required' }]
            },
            {
                name: 'non_standard_driver_charge_abi_gta',
                label: 'Non Standard Driver Charge (ABI GTA)',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_extra_charge_per_day',
                label: 'Total Extras charge per day',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_extra_charged',
                label: 'Total Extras charged',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_claimed',
                label: 'Total Claimed',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_claimed_vat',
                label: 'Total Claimed VAT',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_claimed_abi_gta_with_2_percent_discount',
                label: 'Total Claimed (ABI GTA - With 2% Discount)',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_claimed_vat_abi_gta_with_2_percent_discount',
                label: 'Total Claimed VAT (ABI GTA - With 2% Discount)',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_claimed_abi_gta_amount_only',
                label: 'Total Claimed (ABI GTA Amount Only)',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_claimed_vat_abi_gta_amount_only',
                label: 'Total Claimed VAT (ABI GTA Amount Only)',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_claimed_abi_gta_with_15_percent_lpp',
                label: 'Total Claimed (ABI GTA - With 15% LPP)',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_claimed_vat_abi_gta_with_15_percent_lpp',
                label: 'Total Claimed VAT (ABI GTA - With 15% LPP)',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_claimed_ngta_or_abi_gta_commercial_rate',
                label: 'Total Claimed (NGTA or ABI GTA Commercial Rate)',
                type: 'float',
                validation: {},
            },
            {
                name: 'total_claimed_vat_ngta_or_abi_gta_commercial_rate',
                label: 'Total Claimed VAT (NGTA or ABI GTA Commercial Rate)',
                type: 'float',
                validation: {},
            },
            {
                name: 'grand_total_claimed',
                label: 'Grand Total Claimed',
                type: 'float',
                validation: {},
            },
        ],
    },
];

export const paymentPackTotalsFields = [
    'total_claimed',
    'total_claimed_vat',
    'total_claimed_abi_gta_with_2_percent_discount',
    'total_claimed_vat_abi_gta_with_2_percent_discount',
    'total_claimed_abi_gta_amount_only',
    'total_claimed_vat_abi_gta_amount_only',
    'total_claimed_abi_gta_with_15_percent_lpp',
    'total_claimed_vat_abi_gta_with_15_percent_lpp',
    'total_claimed_ngta_or_abi_gta_commercial_rate',
    'total_claimed_vat_ngta_or_abi_gta_commercial_rate',
    'grand_total_claimed'
];
